import { render, staticRenderFns } from "./received-records.vue?vue&type=template&id=312ddaa0&scoped=true&"
import script from "./received-records.vue?vue&type=script&lang=js&"
export * from "./received-records.vue?vue&type=script&lang=js&"
import style0 from "./received-records.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./received-records.vue?vue&type=style&index=1&id=312ddaa0&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "312ddaa0",
  null
  
)

export default component.exports